/* eslint-disable react/prop-types,max-len */
import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {}),
}));

function parseBallSequenceNumber(ballSequenceNumber) {
  return ballSequenceNumber?.split('_').pop();
}

const PlayInfo = ({
  ballLaunchSequenceNumber,
  ballLaunchTimestamp,
  returnShotType,
  ballBounceLocation,
  groundTruthLastVerifiedTimestamp,
}) => {
  const formatShotType = (shotType) => {
    if (!shotType) return 'Unknown';
    const formatted = shotType
      .split('_')
      .map((word) => word.toLowerCase())
      .join(' ');
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };
  return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            justifyContent="space-between"
            flexWrap="wrap"
        >
            <Item>
                <Typography sx={{ fontSize: '14px', color: '#6656F9' }}>Ball Id</Typography>
                <Typography sx={{ fontSize: '14px', color: '#6656F9', fontWeight: '600' }}>
                    {parseBallSequenceNumber(ballLaunchSequenceNumber)}
                </Typography>
            </Item>
            <Item>
                <Typography sx={{ fontSize: '14px', color: '#6656F9' }}>
                    Ball Launch Timestamp (Pacific time)
                </Typography>
                <Typography sx={{ fontSize: '14px', color: '#6656F9', fontWeight: '600' }}>
                    {ballLaunchTimestamp}
                </Typography>
            </Item>
            <Item>
                <Typography sx={{ fontSize: '14px', color: '#6656F9' }}>Shot type</Typography>
                <Typography sx={{ fontSize: '14px', color: '#6656F9', fontWeight: '600' }}>
                    {formatShotType(returnShotType)}
                </Typography>
            </Item>
            <Item>
                <Typography sx={{ fontSize: '14px', color: '#6656F9' }}>Ball Bounce Location</Typography>
                <Typography sx={{ fontSize: '14px', color: '#6656F9', fontWeight: '600' }}>
                    {ballBounceLocation}
                </Typography>
            </Item>
            <Item>
                <Typography sx={{ fontSize: '14px', color: '#6656F9' }}>
                    Ground Truth Last Verified (Pacific time)
                </Typography>
                <Typography sx={{ fontSize: '14px', color: '#6656F9', fontWeight: '600' }}>
                    {groundTruthLastVerifiedTimestamp}
                </Typography>
            </Item>
        </Stack>
  );
};

export default React.memo(PlayInfo);
